module.exports = __webpack_public_path__ + "img/header.b7a41abe.png";